import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ReportService } from './../../pages/report/report.service'
import { IAuditTrailSummary } from '../../pages/master/models/stockModel';



@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;
  public displayedColumns = ['id','module','createddate','userName','description',];
 
  dataSource = new MatTableDataSource<IAuditTrailSummary>();


  constructor(
    public dialog: MatDialog,
    private ReportService: ReportService,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {

   }

  ngOnInit(): void {
     this.fetchAditEntries();
  }

  fetchAditEntries() {
      this.ReportService.fetchAditHistoryEntries(this.data).subscribe({
        next: (response) => {
          console.log('response', response);
          this.dataSource.data = response || [];
          this.dataSource.paginator = this.paginator;
        }
      });
    
  }


}
